import _ from 'lodash';

export const getCustomers = (context) => {
  const cached = global.getCustomers;

  if (cached && Object.keys(cached).length > 0) {
    return cached;
  }

  const customers = _.get(context, 'entities.customers');
  if (!customers) return [];

  const v = customers.reduce((reduced = [], current) => {
    if (current.CustomerPriceGroup__c) {
      reduced.push(current);
    }
    return reduced;
  }, []);

  global.getCustomers = v;
  return v;
};

export const getCustomerForId = (context, id) => {
  const cached = global.getCustomersById;

  if (cached && cached[id]) {
    return cached[id];
  }

  const customer = getCustomers(context).find((c) => c.Id === id);

  if (customer) {
    if (!global.getCustomersById) {
      global.getCustomersById = {};
    }

    global.getCustomersById[id] = customer;
  }

  return customer || null;
};

export const getCustomerAddresses = (context) => _.get(context, 'entities.customerAddresses');

export const getCustomerAddressesForCustomer = (context, customer) => {
  const customerAddresses = getCustomerAddresses(context);
  if (!customer || !customerAddresses) return [];

  let c = customerAddresses[customer.CustomerNo__c];

  if (c == null) {
	  return [];
  }

  Object.keys(c).forEach((k) => {
    c[k]['shipToCode'] = k;
  });

  return c;
};
